export default __webpack_public_path__ + "static/media/wallet.3d7981b7.svg";